import React from 'react';
import {Card, CardText} from 'material-ui/Card';

const styles = {
  card:{
    margin:10,
  },
  cardheader:{
    paddingBottom:0,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  }
};

export default class SkillCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardText>
          <div>
            Experience With:
            <ul>
              <li>MongoDB, Express, React/Redux, Node.js, Git, Github</li>
              <li>Electron, PouchDB, Next.js (Vercel), Firebase, Amazon Appsync</li>
              <li>Amazon AWS (S3, Elastic Beanstalk/EC2, RDS)</li>
              <li>HTML, CSS, Javascript, Cordova, git</li>
              <li>MySQL, PHP, jQuery</li>
              <li>Google, Microsoft, and Apple software</li>
              <li>Pro/E, Solidworks, MATLAB, AutoCAD</li>
              <li>TIG, MIG welding, Manual/CNC machining, 3D-printing (FDM,SLA)</li>
            </ul>
            Traits:
            <ul>
              <li>Adaptability and willingness to learn what is needed for a project</li>
              <li>Easy to work with and communicate with</li>
              <li>Good work ethic</li>
              <li>Good temperament</li>
            </ul>
          </div>

        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SkillCard.js